(() => {
  document.querySelectorAll('[data-gl-shopify-form]').forEach(panel => {
    const status = panel.querySelector('[data-gl-provider-status]');
    if (!status) return;
    // The app owns its inputs and consent flow. Only monitor its mount state.
    const mounted = () => Boolean(panel.querySelector('shopify-forms-embed'));
    const observer = new MutationObserver(() => {
      if (mounted()) { status.hidden = true; observer.disconnect(); }
    });
    if (mounted()) { status.hidden = true; return; }
    observer.observe(panel, { childList: true, subtree: true });
    setTimeout(() => { if (!mounted()) status.textContent = status.dataset.failed; }, 15000);
    setTimeout(() => observer.disconnect(), 60000);
  });
})();
